var _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoiteringEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 320 297",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 148.5C316.5 228.34 246.683 293.5 160 293.5C73.317 293.5 3.5 228.34 3.5 148.5C3.5 68.66 73.317 3.5 160 3.5C246.683 3.5 316.5 68.66 316.5 148.5Z",
    stroke: "black",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146 17H173V244H146V17Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 254,
    width: 23,
    height: 18,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.167 88.8333V135.917H247.833L231.375 112.375L247.833 88.8333H195.167Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195.167 168.875V135.917M195.167 135.917V88.8333H247.833L231.375 112.375L247.833 135.917H195.167Z",
    stroke: "#00001D",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoiteringEnd);
export default __webpack_public_path__ + "static/media/loitering-end.fb24a554e32bf3eb4bf419c2b6a2a986.svg";
export { ForwardRef as ReactComponent };